import { request } from '@/fetch/core';
import { message } from 'antd';
import moment from 'moment';
import { CockpitMode } from './type';
import { FreeModeClstag, ListenModeClstag, MqttTopic } from './constant';

export async function getOauthToken() {
  const data = {
    grant_type: 'client_credentials',
    client_id: 'REMOTE-DRIVING-CLIENT',
    client_secret: 'REMOTE-DRIVING-CLIENT',
  };
  const requestData: RequestOptions = {
    path: '/oauth2/token',
    body: data,
    method: 'POST',
    contentType: 'application/x-www-form-urlencoded',
  };
  const res = await request(requestData);
  return res;
}

export function stringToEnum<T>(
  enumObj: any,
  strKey: string
): T[keyof T] | undefined {
  if (strKey in enumObj) {
    const key: keyof typeof enumObj = strKey as keyof typeof enumObj;
    return enumObj[key];
  }
  return undefined;
}

export function translatorEnum(keyName: string, value: string) {
  if (!value) {
    return null;
  }
  const enumTranslator = JSON.parse(
    localStorage.getItem('ENUM_LIST_MAP') || '{}'
  );
  const source = enumTranslator[keyName];
  return (
    source?.find((i: { code: string; name: string }) => i.code === value)
      ?.name || value
  );
}
export const mqttPublish = (topic: string, data: string) => {
  (window as any).mqttClient?.publish(topic, data);
};

export const wsSendMessage = (data?: any) => {
  if ((window as any).wsClient.readyState == WebSocket.OPEN) {
    (window as any).wsClient?.send(data);
  }
};

export const returnDashboardOptions = (opt: {
  currentValue: number;
  startAngle?: number;
  endAngle?: number;
  clockwise: boolean;
}) => {
  const { currentValue, startAngle, endAngle, clockwise } = opt;

  return {
    startAngle: startAngle ?? 90,
    endAngle: endAngle ?? -270,
    clockwise,
    min: 0,
    max: 240,
    lineWidth: 20,
    value: Math.abs(currentValue),
  };
};

export const transFormAngle = (angle: number) => {
  return angle ? parseFloat(((angle * 180) / 3.14).toFixed(1)) : 0;
};

export const isEmpty = (param: any) => {
  if (Array.isArray(param) || typeof param === 'string') {
    return param.length === 0;
  }
  return true;
};

export const isNullObject = (obj: any) => {
  if (!obj) {
    return true;
  }
  return Object.keys(obj).length === 0;
};

export const transTimeStamp = (delta: number) => {
  if (delta < 60000) {
    return '<1min';
  } else if (delta >= 60000 && delta < 3600000) {
    return `${Math.floor(delta / 60000)}min`;
  } else if (delta >= 3600000 && delta < 86400000) {
    const t1 = Math.floor(delta / 3600000);
    const t2 = Math.floor((delta % 3600000) / 60000);
    return `${t1}h${t2}min`;
  }

  return '24h+';
};

export const formatTimeStamp = (timeStamp: any) => {
  let now = new Date(timeStamp);
  return now.toTimeString().substr(0, 8);
};

export const transIssueDurationTime = (delta: number) => {
  if (delta < 60000) {
    return `${Math.floor(delta / 1000)}秒`;
  } else if (delta >= 60000 && delta < 3600000) {
    const t1 = Math.floor(delta / 60000);
    let t2: any = Math.floor((delta % 60000) / 1000);
    t2 = t2 < 10 ? `0${t2}` : t2;
    return `${t1}分钟${t2}秒`;
  } else {
    const t1 = Math.floor(delta / 3600000);
    const t2 = Math.floor((delta % 3600000) / 60000);
    return `${t1}小时${t2}分钟`;
  }
};

export const timeRules = (timeStamp: any) => {
  if (!timeStamp) {
    return;
  }
  const result: any = {};
  const now = Date.now();
  const startTime = new Date(timeStamp);
  const delta = now - startTime.getTime();
  const timeStr = transTimeStamp(delta);
  result.timeStr = timeStr;
  const rulesMap = new Map([
    ['0,60000', '#fff'],
    ['60000,600000', '#fff'],
    ['600000,3600000', '#FF463A'],
    ['3600000,86400000', '#FF463A'],
    ['86400000,9999999999999999', '#FF463A'],
  ]);

  for (const [key, value] of rulesMap) {
    const temp = key.split(',');
    const left = parseInt(temp[0]);
    const right = parseInt(temp[1]);
    if (delta >= left && delta < right) {
      result.color = value;
      break;
    }
  }

  return result;
};

/**
 *
 * @param {string} enumGroupKey 枚举分组key
 * @param {string} fieldKey 字段key
 * @return {Object}
 */
export const enumTranslator = (enumGroupKey: string, fieldKey: string) => {
  const win = window as any;
  const { common } = win.store.getState();
  const enumListMap = common.enumListMap;
  const storageMap = JSON.parse(localStorage.getItem('ENUM_LIST_MAP') || '{}');
  const mapEnum =
    enumListMap &&
    enumListMap[enumGroupKey] &&
    enumListMap[enumGroupKey].find((item: any) => item.code === fieldKey);
  if (!mapEnum) {
    return (
      (storageMap[enumGroupKey] &&
        storageMap[enumGroupKey].find((item: any) => item.code === fieldKey) &&
        storageMap[enumGroupKey].find((item: any) => item.code === fieldKey)
          .name) ||
      fieldKey
    );
  }
  return mapEnum.name;
};

export const formatDuration = (startTime: string, endTime: string) => {
  if (endTime) {
    return moment(moment(endTime).diff(moment(startTime)))
      .utc()
      .format('HH:mm:ss');
  } else {
    if (moment(startTime).isBefore(moment().startOf('day'))) {
      const tPlusOneTime = moment(startTime).add(1, 'd').startOf('day');
      return moment(tPlusOneTime.diff(moment(startTime)))
        .utc()
        .format('HH:mm:ss');
    } else {
      return moment(moment().diff(moment(startTime)))
        .utc()
        .format('HH:mm:ss');
    }
  }
};

export const showMsg = ({
  msg,
  type,
  duration,
  onClose,
}: {
  msg: string;
  type: 'success' | 'error' | 'info' | 'warning' | 'loading';
  duration?: number;
  onClose?: AnyFunc;
}) => {
  switch (type) {
    case 'success':
      message.success(msg, duration, onClose);
      break;
    case 'error':
      message.error(msg, duration, onClose);
      break;
    case 'info':
      message.info(msg, duration, onClose);
      break;
    case 'warning':
      message.success(msg, duration, onClose);
      break;
    case 'loading':
      message.success(msg, duration, onClose);
      break;
  }
};

export const formatSelectOptions = (
  list: { code: string | number; name: string }[] | null
) => {
  if (!list) {
    return [];
  }
  return list.map((item) => {
    return {
      label: item.name,
      value: item.code,
    };
  });
};

export const formatCommonCategory = (categoryList: any[]): any[] => {
  const res: any = [];
  categoryList &&
    categoryList.forEach((category: any, index: number) => {
      !category.child && res.push([category.id]);
      category.child &&
        category.child.forEach((item: any, idx: number) => {
          res.push([category.id, item.id]);
        });
    });
  return res;
};

export function debounce(fn: any, wait: number = 50) {
  let timer: any = null;
  const debounced = function (..._args: any) {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      fn.apply(null, _args);
    }, wait);
  };
  return debounced;
}

export function debounceImmediate(func: AnyFunc, wait: number) {
  let timeout: any = null;
  let immediate = true;
  const debouncedImmediate = function (...args: any) {
    if (immediate) {
      func.apply(null, args);
      immediate = false;
    }
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      immediate = true;
    }, wait);
  };
  return debouncedImmediate;
}

export function getBase64(file: any) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export const getPermissionById = (id: string) => {
  const store = (window as any).store;
  if (!store) {
    return false;
  }
  const state = store.getState();
  const { userInfo } = state.login;
  if (userInfo?.resourceList) {
    const findIndex = userInfo.resourceList.findIndex(
      (item: any) => item.code === id
    );
    return findIndex > -1;
  }
  return false;
};

// 是否存在障碍
export const isObstacle = (value: any) => {
  if (typeof value == 'boolean' && !value) {
    return true;
  }
  return false;
};

export const formatCurDateTime = (currentDateTime: Date) => {
  const year = currentDateTime.getFullYear();
  const month = String(currentDateTime.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以要加1
  const day = String(currentDateTime.getDate()).padStart(2, '0');
  const hours = String(currentDateTime.getHours()).padStart(2, '0');
  const minutes = String(currentDateTime.getMinutes()).padStart(2, '0');
  const seconds = String(currentDateTime.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
// 行为埋点tag
export const clstagStr = (logId: string) => {
  return `h|keycount|${logId}`;
};

// 自定义行为埋点事件
export const analyzeLog = (key: string, value: string | object) => {
  try {
    (window as any).log('jdxmonitor', key, value);
  } catch (e) {
    console.log(e);
  }
};

export const getClstag = (mode: CockpitMode, key: string) => {
  if (mode === CockpitMode.FREE_MODE) {
    return clstagStr(FreeModeClstag[key as keyof typeof FreeModeClstag]);
  } else if (mode === CockpitMode.LISTENING_MODE) {
    return clstagStr(ListenModeClstag[key as keyof typeof ListenModeClstag]);
  }
};

export const cloudFetchConfig = (path: string) => {
  return {
    absoluteURL: `${location.protocol}//${process.env.JDX_APP_CLOUD_FETCH_DOMAIN}${path}`,
    headers: {
      'LOP-DN': process.env.JDX_APP_REQUEST_HEADER!,
    },
  };
};

export const isNumber = (value: any): boolean => {
  if (value === null || value === undefined) return false;
  if (typeof value === 'number') return !isNaN(value);
  if (typeof value === 'string') {
    const parsed = parseFloat(value);
    return !isNaN(parsed) && isFinite(parsed);
  }
  return false;
};

export const convertSpeedMsToKmh = (
  speedMs: any,
  numberOfDecimalPlaces?: number
): string => {
  if (isNumber(speedMs)) {
    if (Number(speedMs) === 0) {
      return '0 km/h';
    }
    if (numberOfDecimalPlaces !== undefined) {
      return `${(speedMs * 3.6).toFixed(numberOfDecimalPlaces)} km/h`;
    }
    return `${speedMs * 3.6} km/h`;
  } else {
    return '--';
  }
};

export const videoExtensions = [
  '.mp4',
  '.avi',
  '.mov',
  '.wmv',
  '.flv',
  '.webm',
  '.mkv',
  '.m4v',
  '.ogm',
  '.mpg',
  '.ogv',
  '.asx',
  '.mpeg',
];

export const imageExtensions = [
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
  '.bmp',
  '.webp',
  '.svg',
  '.tif',
  '.tiff',
  '.xbm',
  '.jfif',
  '.pjp',
  '.apng',
  '.heif',
  '.ico',
  '.svgz',
  '.heic',
  '.pjpeg',
  '.avif',
];

export const sgmReport = (path: any, data: any) => {
  try {
    (window as any).__sgm__.api({
      url: `http://localhost:10001/${path}`,
      status: 201,
      responseData: data,
    });
  } catch (e) {
    console.log(e);
  }
};

export const qidianImpLog = (clstag: string, ext?: any) => {
  try {
    if ((window as any).__qd__) {
      (window as any).__qd__.imp({
        cls: clstag,
        v: ext || null,
      });
    }
  } catch (e) {
    console.log(e);
  }
};
export const qidianClickLog = (clstag: string, ext?: any) => {
  try {
    // 使用条件检查代替短路运算符
    if ((window as any).__qd__) {
      (window as any).__qd__.click({
        cls: clstag,
        v: ext || null,
      });
    }
  } catch (e) {
    console.log(e);
  }
};

export const sgmReportCustom = (type: number, code: string, msg: string) => {
  try {
    (window as any).__sgm__.custom({ type, code, msg });
  } catch (e) {
    console.log(e);
  }
};
